// extracted by mini-css-extract-plugin
export var content = "Cta-module--content--074d0";
export var cta = "Cta-module--cta--3c8ef";
export var headline = "Cta-module--headline--09c02";
export var white = "Cta-module--white--a3290";